import { useAuthStore } from '../store/authStore';
import type { User } from '../types';

/**
 * Checks whether a user has a given permission key, granted via their
 * assigned role (public.roles -> public.role_permissions -> public.permissions).
 * Safe against custom roles whose permissions aren't backed by RLS yet -
 * this only reflects app-layer/UI access, see plan section 6 for the
 * RLS-ceiling caveat on what each permission actually enforces at the DB layer.
 */
export function hasPermission(user: User | null | undefined, permissionKey: string): boolean {
  return !!user?.permissionKeys?.includes(permissionKey);
}

/** Component-friendly hook wrapping `hasPermission` against the current session user. */
export function usePermission(permissionKey: string): boolean {
  const user = useAuthStore((state) => state.user);
  return hasPermission(user, permissionKey);
}
